import React from 'react';
import { string, bool, arrayOf, shape } from 'prop-types';

import IconBuilder from '../icon-builder';

const namespace = `content-pill-option`;

const Pilss = ({ accessibility_text, color, text, values }) => (
  <div className={`${namespace} ${color && `${namespace}--free`}`} aria-label={accessibility_text}>
    {values.map((value) => (
      <div key={value.id} className={`${namespace}-icon`}>
        {IconBuilder[value.id]}
      </div>
    ))}
    <span>{text}</span>
  </div>
);

Pilss.propTypes = {
  accessibility_text: string,
  color: bool,
  text: string,
  values: arrayOf(
    shape({
      id: string,
    }),
  ),
};

export default Pilss;
